import React, { Ref } from "react";

import { StrainRelative } from "custom-types/StrainV2";

import StrainLineageLink from "./StrainLineageLink";

type Props = {
  parentRef: Ref<HTMLDivElement>;
  parent: StrainRelative;
};

const StrainLineageSingleParent = ({ parentRef, parent }: Props) => (
  <div className="col-[1/7] row-[1/3]" ref={parentRef}>
    <StrainLineageLink
      strain={parent}
      altText="Strain parent"
      parentOrChild="parent"
    />
  </div>
);

export default StrainLineageSingleParent;
